export const viewShiftFormPath = {
  parent: "view-shift",
  parentClone: "view-shift-clone",
};
